module.exports = __webpack_public_path__ + "img/bolt.2aa41b08.svg";